import { useMutation, useQueryClient, type QueryClient } from '@tanstack/react-query'
import { api } from './api'

/*
  Notificarile se vad in doua locuri — clopotelul din antet si „Noutăți" pe Acasă. Orice
  marcare le reimprospateaza pe amandoua; altfel una ramane „necitită" dupa ce ai citit-o in
  cealalta (Madalin, 19.10.2026).
*/
const CHEI = [['notifications-unread'], ['notifications-list'], ['acasa', 'noutati']] as const

/**
 * Notificarile care sunt SOLICITARI: cineva asteapta ceva de la tine — marfa de aprobat, o comanda
 * de aprobat, un task dat tie, un colet de pregatit, un transfer de livrat, codul eMag. Necitite,
 * ies in rosu (Victor, 19.10.2026: „sa avem o culoare pronuntata pentru orice tip de solicitare
 * noua"). Restul — mentiuni, mutari, task-uri revenite — raman informari.
 */
const SOLICITARI = new Set([
  'cerere_marfa_trimisa',
  'order_pending_approval',
  'task_assigned',
  'task_privat_primit',
  'task_dat_inapoi',
  // Un task devenit urgent cere atentie acum (Madalin, 27.10.2026).
  'task_urgent',
  'colet_de_pregatit',
  'transfer_de_livrat',
  'emag_otp_needed',
])

export const esteSolicitare = (kind: string | null | undefined) => !!kind && SOLICITARI.has(kind)

/**
 * Task terminat („X a terminat …”) — iese in VERDE, citit sau nu (Victor, 21.10.2026: „ce s-a
 * finalizat sa fie cu verde"). Doar `gata`: un task respins sau arhivat are felul `cerere_respinsa`.
 */
export const esteTaskTerminat = (kind: string | null | undefined) => kind === 'cerere_gata'

const reimprospateaza = (qc: QueryClient) =>
  Promise.all(CHEI.map((queryKey) => qc.invalidateQueries({ queryKey: [...queryKey] })))

/** O notificare citita — la clic pe ea, oriunde ar fi. */
export function useCitesteNotificarea() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => (await api.post(`/notifications/${id}/read`)).data,
    onSuccess: () => reimprospateaza(qc),
  })
}

/** Toate citite. */
export function useCitesteToateNotificarile() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => (await api.post('/notifications/read-all')).data,
    onSuccess: () => reimprospateaza(qc),
  })
}

/** Notificarile unui task, citite cand i se deschide panoul — oricum ai ajuns la el. */
export function useCitesteNotificarileTaskului() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (taskId: number) =>
      (await api.post<{ updated: number }>(`/notifications/read-task/${taskId}`)).data,
    // Fara cereri in plus cand n-avea nimic necitit — cazul obisnuit.
    onSuccess: (r) => {
      if (r.updated > 0) void reimprospateaza(qc)
    },
  })
}
